/**
 * list of the object to be considered as focusable
 */
export var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/focus-lock/dist/es2015/utils/tabbables.js
// module id = 1149
// module chunks = 0